import { render, staticRenderFns } from "./SelectBuscaApi.vue?vue&type=template&id=f9210990&"
import script from "./SelectBuscaApi.vue?vue&type=script&lang=js&"
export * from "./SelectBuscaApi.vue?vue&type=script&lang=js&"
import style0 from "./SelectBuscaApi.vue?vue&type=style&index=0&id=f9210990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports